import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=5976199e&scoped=true&"
import script from "./Cabecalho.vue?vue&type=script&lang=js&"
export * from "./Cabecalho.vue?vue&type=script&lang=js&"
import style0 from "./Cabecalho.vue?vue&type=style&index=0&id=5976199e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976199e",
  null
  
)

export default component.exports